import { Typography } from '@mui/material';
import menuItem from '../../../../menu-items';
import { getAllowedRoutes } from '../../../../routes/getAllowRoutes';
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';

interface MenuListProps {
  open?: boolean;
}
const MenuList: React.FC<MenuListProps> = ({ open }: MenuListProps) => {
  const routes = getAllowedRoutes(menuItem.items);
  const navItems = routes.map((item) => {
    switch (item.type) {
      case 'collapse':
        return <NavCollapse key={item.id} menu={item} open={open} />;
      case 'item':
        return <NavItem key={item.id} item={item} open={open} />;
      case 'hidden':
        return null;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
